import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard, AuthGuardAdmin} from "./resolvers/auth.guard";
import {FastRegisterComponent} from "./pages/fast-register/fast-register.component";


const routes: Routes = [

      {
      path: 'registrazione-autonoma/inviata',
      data: { submitted: true },
      loadComponent: () =>
         import('./pages/self-register/self-register.component')
            .then(m => m.SelfRegisterComponent)
   },

   {
      path: 'registrazione-autonoma',
      loadComponent: () =>
         import('./pages/self-register/self-register.component')
            .then(m => m.SelfRegisterComponent)
   },

   {
      path: 'ng',
      loadChildren: () => import('./pages/root/root.module').then(m => m.RootModule),
      canActivate: [AuthGuard],

   },

   {
      path: 'admin',
      canActivate: [AuthGuardAdmin],
      loadChildren: () => import('./pages/root-admin/root-admin.module').then(m => m.RootAdminModule)
   },

   { path: 'register', loadChildren: () => import('./pages/register/register.module').then(m => m.RegisterModule) },
   { path: 'fast-register', loadComponent: () => import('./pages/fast-register/fast-register.component').then(m => FastRegisterComponent) },
   { path: 'reset_password', loadChildren: () => import('./pages/register/reset-password/reset-password.module').then(m => m.ResetPasswordModule) },

   { path: '', redirectTo: '/ng/esercizi', pathMatch: 'full' },
   { path: '**', redirectTo: '/ng/esercizi', pathMatch: 'full' },
];


@NgModule({
   imports: [RouterModule.forRoot(routes)],
   exports: [RouterModule]
})
export class AppRoutingModule { }
